import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { TRADES, toSlug } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function TradesGrid() {
  const r = useReveal();

  return (
    <section id="trades" className="bg-ls-alt py-20 md:py-28 border-t" style={{ borderColor: "var(--ls-border)" }}>
      <div ref={r.ref} className={`max-w-7xl mx-auto px-5 md:px-8 ${r.className}`}>
        <p className="ls-eyebrow mb-4">Trades we serve</p>
        <h2 className="font-display text-white text-[9vw] sm:text-5xl md:text-6xl max-w-4xl mb-5">
          Trades We <span className="text-orange">Serve.</span>
        </h2>
        <p className="text-lg text-[#c7bdae] max-w-3xl mb-12">
          We build this system for real home service pros. Pick your trade to see how we help contractors like you
          book more jobs.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {TRADES.map((t) => {
            const Icon = Icons[t.icon] || Icons.Hammer;
            return (
              <Link
                key={t.name}
                to={`/${toSlug(t.name)}`}
                className="card-dark p-5 flex items-center gap-4 text-left group"
              >
                <span
                  className="flex items-center justify-center w-11 h-11 rounded-[6px] shrink-0 transition-colors"
                  style={{ backgroundColor: "rgba(242,106,33,0.12)" }}
                >
                  <Icon className="w-5 h-5 text-orange" />
                </span>
                <span className="font-cond font-bold text-lg text-white uppercase tracking-wide group-hover:text-orange transition-colors flex-1">
                  {t.name}
                </span>
                <ArrowUpRight className="w-4 h-4 text-[#7d7264] group-hover:text-orange transition-colors shrink-0" />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
